// extracted by mini-css-extract-plugin
export default {"accHeader":"Attestation_accHeader__23Vx5","collapsed":"Attestation_collapsed__33jhq","accordion":"Attestation_accordion__w36g4"};